import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

export default function TelegramIcon({ fill = '#2BACEE' }) {
    return (
        <SvgIcon style={{ width: 48, height: 48 }}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="8" fill={fill} />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.4931 22.7489C20.3235 20.2087 24.2114 18.534 26.1567 17.7249C31.7109 15.4147 32.865 15.0134 33.6173 15.0001C33.7827 14.9972 34.1526 15.0382 34.3923 15.2327C34.5946 15.3968 34.6503 15.6186 34.6769 15.7743C34.7035 15.93 34.7367 16.2846 34.7103 16.5616C34.4094 19.7241 33.107 27.3986 32.4444 30.9406C32.1641 32.4394 31.6121 32.9419 31.0776 32.9911C29.9162 33.098 29.0342 32.2235 27.9093 31.4861C26.1491 30.3323 25.1546 29.614 23.446 28.488C21.4714 27.1868 22.7514 26.4716 23.8768 25.3027C24.1713 24.9969 29.2886 20.3423 29.3876 19.92C29.4 19.8672 29.4115 19.6704 29.2946 19.5664C29.1776 19.4625 29.0051 19.498 28.8805 19.5263C28.704 19.5664 25.8919 21.425 20.4444 25.1022C19.6462 25.6503 18.9232 25.9174 18.2755 25.9034C17.5614 25.888 16.1877 25.4996 15.1665 25.1677C13.914 24.7606 12.9186 24.5453 13.0053 23.8539C13.0504 23.4937 13.5464 23.1254 14.4931 22.7489Z"
                    fill="white"
                />
            </svg>
        </SvgIcon>
    );
}
